'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prismicRichTextAsHTML = exports.PrismicRichText = undefined;

var _prismicReactjs = require('prismic-reactjs');

var _prismicDom = require('prismic-dom');

var PrismicRichText = exports.PrismicRichText = function PrismicRichText(_ref) {
  var children = _ref.children,
      linkResolver = _ref.linkResolver,
      htmlSerializer = _ref.htmlSerializer;
  return _prismicReactjs.RichText.render(children, linkResolver, htmlSerializer);
};

var prismicRichTextAsHTML = exports.prismicRichTextAsHTML = function prismicRichTextAsHTML(content, linkResolver, htmlSerializer) {
  return _prismicDom.RichText.asHtml(content, linkResolver, htmlSerializer);
};


//////////////////
// WEBPACK FOOTER
// ../~/prismic-utils/dist/utils/index.js
// module id = 1224
// module chunks = 0